/** 
 * Renders the social media links on the navigation bar for desktop
 */
import React from "react";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import { SiLinktree } from "react-icons/si";

const SocialsLinks = () => {
    return (
  <ul className="flex flex-row justify-center items-center">
    <li className="social-item transition-transform duration-200 ease-in-out transform hover:scale-110">
      <a
        href="https://www.instagram.com/buihainfo"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaInstagram className="w-8 h-8 mx-1 text-pink-500" />
      </a>
    </li>
    <li className="social-item transition-transform duration-200 ease-in-out transform hover:scale-110">
      <a
        href="https://www.facebook.com/buihainfo"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaFacebook className="w-8 h-7 mx-1 text-blue-600" />
      </a>
    </li>
    <li className="social-item transition-transform duration-200 ease-in-out transform hover:scale-110">
      <a
        href="https://www.youtube.com/@buihastream"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaYoutube className="w-8 h-8 mx-1 text-red-600" />
      </a>
    </li>
    {/*<li className="social-item transition-transform duration-200 ease-in-out transform hover:scale-110">*/}
    {/*  <a*/}
    {/*    href="https://www.linktr.ee/buihainfo"*/}
    {/*    target="_blank"*/}
    {/*    rel="noopener noreferrer"*/}
    {/*  >*/}
    {/*    <SiLinktree className="w-8 h-7 mx-1 text-green-500" />*/}
    {/*  </a>*/}
    {/*</li>*/}
  </ul>
    );
}
export default SocialsLinks;
